import { getOptions } from '../EChartUtils'

class _Candlestick {
    constructor(obj) {
        this.obj = obj
    }

    getDefaultOptions = () => {
        return {
            name: 'bar chart',
            type: 'candlestick',
            data: [],
            areaStyle: {
                normal: {},
            },
            itemStyle: {
                normal: {
                    color: 'blue',
                },
            },
        }
    }

    updateObj = (changes) => {
        this.obj = { ...this.obj, ...changes }
    }

    getJson = () => {
        const options = getOptions(this.obj, this.getDefaultOptions(), {
            color: () => (
                {
                    areaStyle: {
                        normal: {
                            color: this.obj.color,
                            opacity: 1,
                        },
                    },
                    itemStyle: {
                        normal: {
                            color: this.obj.color,
                            opacity: 1,
                            color0: 'black',
                            borderColor: 'black',
                            borderColor0: 'black',
                        },
                    },
                }),
        })
        return options
    }
}

export default function Candlestick(args) {
    return new _Candlestick(args)
}
